import { render } from "./MessageForm.vue?vue&type=template&id=c4863306&scoped=true&ts=true"
import script from "./MessageForm.vue?vue&type=script&lang=ts"
export * from "./MessageForm.vue?vue&type=script&lang=ts"

import "./MessageForm.vue?vue&type=style&index=0&id=c4863306&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4863306"]])

export default __exports__